import React, { Fragment, memo, useMemo } from "react";
import { Line } from "react-konva";

interface Props {
  template: Array<Array<number>>;
  scale: number;
  projection: Array<Array<number>> | null;
}

const Projection: React.FunctionComponent<Props> = (props) => {
  const lines = useMemo(() => {
    const ret = [];
    if (props.projection && props.projection.length === props.template.length) {
      let i = 0;

      let width = 0;
      while (props.template[i][1] === 0) i++;
      width = i;
      const height = props.projection.length / width;

      for (i = 0; i < height; i++) {
        ret.push(
          props.projection
            .slice(i * width, (i + 1) * width)
            .flatMap((p) => [...p])
        );
      }
      for (i = 0; i < width; i++) {
        const add = [];
        for (let j = 0; j < height; j++) {
          add.push(props.projection[i + j * width][0]);
          add.push(props.projection[i + j * width][1]);
        }
        ret.push(add);
      }
    }
    return ret.map((p) => p.filter((p2) => p2 !== -1));
  }, [props.projection, props.template]);
  return props.projection ? (
    <Fragment>
      {lines.map((l, i) => {
        const ret = (
          <Line
            key={i}
            points={l}
            stroke="red"
            strokeWidth={Math.ceil(1 / (4 * props.scale))}
          />
        );
        return ret;
      })}
    </Fragment>
  ) : (
    <Fragment />
  );
};

export default memo(Projection);
